<h4 class="fw-600 mtn">{{ product.program.name }}</h4>
<div class="d-flex">
  @for (index of _.range(5); track index) {
    <pr-icon
      [name]="
        index + 1 <= product.program.globalScore / 4
          ? 'sp-star_filled'
          : 'sp-star_outline'
      "
      [viewBoxWidth]="24"
      [viewBoxHeight]="22"
    ></pr-icon>
  }
</div>
<span class="fs-12 fw-400 text-sec"
  >Ce bien est noté <b>{{ product.program.globalScore / 4 }}/5</b> par notre
  algorithme</span
>
